// extracted by mini-css-extract-plugin
export default {"thankyou":"Thankyou_thankyou__QnzfV","success":"Thankyou_success__O-D6t","buttonGroup":"Thankyou_buttonGroup__Z8rTN","error":"Thankyou_error__o6d01"};